import { useEffect } from "react";
import { Item } from "types";
import { useItems } from "atoms/itemAtom";

import { Divider } from "components/Divider/Divider";

import { useFilterProducts } from "../hooks";
import styles from "../styles.module.scss";

import { ProductsHeader, ProductItem } from "./index";

type ProductsListProps = {
  items: Item[];
  searchText: string;
};

export const ProductsList = ({
  items,
  searchText,
}: ProductsListProps): JSX.Element => {
  const filteredProducts = useFilterProducts(items, searchText);
  const { itemsState, setItemsState } = useItems();

  useEffect(() => {
    if (itemsState.checkedItems.length) {
      setItemsState({
        checkedItems: filteredProducts.filter((temp) => {
          return itemsState.checkedItems.some(
            (tempItem) => tempItem.itemid === temp.itemid
          );
        }),
      });
    }
  }, [filteredProducts]);

  return (
    <div className={styles.productsList}>
      <ProductsHeader productsList={filteredProducts} />
      <Divider />
      {filteredProducts.map((item) => (
        <ProductItem item={item} key={item.itemid ?? Math.random() + "-"} />
      ))}
    </div>
  );
};
